import React, { useEffect } from 'react';

const FrenchPrefixHandler = () => {
  useEffect(() => {
    const addFrenchPrefix = () => {
      // Check if current URL contains /fr/
      const currentUrl = window.location.href;
      const isFrenchVersion = currentUrl.includes('/fr/');
      
      if (!isFrenchVersion) return;
      
      // Get current domain and protocol
      const currentDomain = window.location.origin;
      
      // Find all links on the page
      const links = document.querySelectorAll('a[href]');
      
      links.forEach(link => {
        const href = link.getAttribute('href');
        
        // Skip if:
        // - External links (starts with http/https but not current domain)
        // - Already has /fr/ prefix
        // - Anchor links (#)
        // - JavaScript links
        // - mailto/tel links
        if (
          !href ||
          href.startsWith('#') ||
          href.startsWith('javascript:') ||
          href.startsWith('mailto:') ||
          href.startsWith('tel:') ||
          href.includes('/fr/') ||
          (href.startsWith('http') && !href.startsWith(currentDomain))
        ) {
          return;
        }
        
        let newHref = '';
        
        // Handle different types of internal links
        if (href.startsWith('/')) {
          // Absolute path from root
          newHref = `/fr${href}`;
        } else if (href.startsWith(currentDomain)) {
          // Full URL with current domain
          newHref = href.replace(currentDomain, `${currentDomain}/fr`);
        } else if (!href.startsWith('http')) {
          // Relative path
          newHref = `/fr/${href}`;
        } else {
          // Keep original if it doesn't match our criteria
          return;
        }
        
        // Update the href attribute
        link.setAttribute('href', newHref);
      });
    };
    
    // Run immediately
    addFrenchPrefix();
    
    // Also run when DOM changes (for dynamically added content)
    const observer = new MutationObserver((mutations) => {
      let shouldUpdate = false;
      
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              // Check if the added node is a link or contains links
              if (node.tagName === 'A' || node.querySelector('a')) {
                shouldUpdate = true;
              }
            }
          });
        }
      });
      
      if (shouldUpdate) {
        // Delay execution slightly to ensure DOM is fully updated
        setTimeout(addFrenchPrefix, 100);
      }
    });
    
    // Start observing
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    
    // Cleanup function
    return () => {
      observer.disconnect();
    };
  }, []);
  
  // This component renders nothing (no UI)
  return null;
};

export default FrenchPrefixHandler;